import { render, staticRenderFns } from "./JgpGridCol.vue?vue&type=template&id=162cd0d8&"
import script from "./JgpGridCol.vue?vue&type=script&lang=js&"
export * from "./JgpGridCol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports